// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__ncah9","modalOverlay":"Modal_modalOverlay__ZrB5u","image":"Modal_image__PGSjp"};